<template>
  <div class="json-input">
    <div class="label">{{label}}</div>
    <codemirror v-model="json" :options="cmOptions"></codemirror>
  </div>
</template>
<script>
  import { codemirror } from 'vue-codemirror'
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/javascript/javascript.js'
  // import 'codemirror/theme/monokai.css'
  // require active-line.js
  import 'codemirror/addon/selection/active-line.js'
  // highlightSelectionMatches
  import 'codemirror/addon/scroll/annotatescrollbar.js'
  import 'codemirror/addon/search/matchesonscrollbar.js'
  import 'codemirror/addon/search/searchcursor.js'
  import 'codemirror/addon/search/match-highlighter.js'
  // styleSelectedText
  import 'codemirror/addon/selection/mark-selection.js'
  import 'codemirror/addon/fold/foldgutter.css'
  import 'codemirror/addon/fold/brace-fold.js'
  import 'codemirror/addon/fold/comment-fold.js'
  import 'codemirror/addon/fold/foldcode.js'
  import 'codemirror/addon/fold/foldgutter.js'
  import 'codemirror/addon/fold/indent-fold.js'
  let beautify = require('js-beautify').js
  export default {
    name: 'json-input',
    data () {
      return {
        cmOptions: {
          tabSize: 2,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: {
            name: 'javascript',
            json: true
          },
          lineWrapping: true,
          theme: 'default'
        },
        typeError: false
      }
    },
    computed: {
      json: {
        get () {
          let json = JSON.stringify(this.value)
          if (json) return beautify(json, { indent_size: 2, space_in_empty_paren: true })
        },
        set (val) {
          try {
            let json = JSON.parse(val)
            this.$emit('input', json)
            this.typeError = false
          } catch (e) {
            this.typeError = true
          }
        }
      },
      hasError () {
        return this.error || this.typeError
      }
    },
    props: {
      value: String | Object | Number,
      label: String,
      error: String
    },
    components: {
      codemirror
    }
  }
</script>
<style lang="scss" scoped>
  .label {
    line-height: 20px;
    font-size: 12px;
    color: rgba(0,0,0,.54);
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/jsonInput.vue